
import { all, call } from 'redux-saga/effects';
import loadDataSaga from './loadData';
import loadPlanSaga from './loadPlan';
import savePlanSaga from './savePlan';
import newPlanSaga from './newPlan';
import newFeaturesSaga from './newFeatures';

// All sagas to be loaded
export default function* () {
  yield all([
    call(loadDataSaga),
    call(loadPlanSaga),
    call(savePlanSaga),
    call(newPlanSaga),
    call(newFeaturesSaga),
  ]);
}
